module.exports = {
      id: "spotify-color-icon-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#spotify-color-icon",
      toString: function () {
        return this.url;
      }
    }